import FormInputDate from "../../../../../../packages/design-system/src/FormInputDate";
import { FormInputDateDemo } from "../../../../../../packages/design-system/src/FormInputDate/readme-helpers";
import * as React from 'react';
export default {
  FormInputDate,
  FormInputDateDemo,
  React
};